// extracted by mini-css-extract-plugin
module.exports = {"container":"card-image-type-3-m__container__1awGX","image-view":"card-image-type-3-m__image-view__2Gzjy"};